<template>
    <div class="table-responsive">
        <vue-perfect-scrollbar style="height: 408px">
            <v-data-table
                v-if="(device_alerts || []).length > 0"
                :headers="headers"
                :items="device_alerts"
                :no-data-text="$t('lang.no_data_available')"
                hide-actions
            >
                <template slot="items" slot-scope="props">
                    <tr class="clickable" @click="$router.push({ name: 'device', params: { id: props.item.device_id } })">
                        <td class="text-center">
                            <h3>{{ props.item.public_id }}</h3>
                        </td>
                        <td>
                            <b>{{ props.item.label ? props.item.label : "---" }}</b
                            ><br /><small>{{ props.item.location_label ? props.item.location_label : "---" }}</small>
                        </td>
                        <td class="text-center">
                            <v-chip
                                label
                                color="warning"
                                text-color="white"
                                small
                                v-if="props.item.yellow_active != null && props.item.yellow_active != '' && props.item.yellow_active != '0'"
                                class="mr-1"
                                >{{ props.item.yellow_active }}</v-chip
                            >
                            <small v-else>---</small>
                        </td>
                        <td class="text-center">
                            <v-chip
                                label
                                color="error"
                                text-color="white"
                                small
                                v-if="props.item.red_active != null && props.item.red_active != '' && props.item.red_active != '0'"
                                class="mr-1"
                                >{{ props.item.red_active }}</v-chip
                            >
                            <small v-else>---</small>
                        </td>
                        <td class="text-center">
                            <v-icon
                                color="error"
                                v-if="props.item.temperature_active != null && props.item.temperature_active != '' && props.item.temperature_active != '0'"
                                >device_thermostat</v-icon
                            >
                            <small v-else>---</small>
                        </td>
                        <td class="text-center">
                            {{ props.item.users_last_record_date ? props.item.users_last_record_date : "---" }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </vue-perfect-scrollbar>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>

<script>
import api from "Api";
import { mapActions, mapState } from "vuex";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
export default {
    data() {
        return {
            loader: false,
            headers: [
                {
                    text: this.$t("lang.device_num"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                { text: this.$t("lang.company"), sortable: false, width: "30%" },
                { text: this.$t("lang.mild"), sortable: false, align: "center", width: "15%" },
                {
                    text: this.$t("lang.urgent"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    text: this.$t("lang.temperature"),
                    sortable: false,
                    align: "center",
                    width: "15%",
                },
                {
                    text: this.$t("lang.last_record_date"),
                    sortable: false,
                    align: "center",
                    width: "20%",
                },
            ],
        };
    },
    watch: {
        dashboard_device_alerts_page_num: {
            handler: function (val, oldVal) {
                this.refresh();
            },
            deep: true,
        },
    },
    mounted() {
        this.refresh();
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices.devices,
            device_alerts: (state) => state.devices.device_alerts,
            default_filter: (state) => state.devices.devices_filter,
            page: (state) => state.devices.device_alerts_page,
            dashboard_device_alerts_page_num: (state) => state.devices.dashboard_device_alerts_page_num,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDevices"]),
        refresh() {
            this.loader = true;
            this.$store.commit("mutate", {
                property: "device_alerts",
                with: [],
            });
            this.fetchDevices({
                body: {
                    has_alerts: "1",
                    page_num: this.dashboard_device_alerts_page_num,
                    tags: this.current_user.tags_filter !== null ? [...this.current_user.tags_filter.split(",")] : [],
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "device_alerts",
                    with: [...this.devices],
                });
                this.loader = false;
            });
        },
    },
    components: {
        AppSectionLoader,
    },
};
</script>
